import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import type { usePlatformStore } from './store.js';

const startupRequests = new WeakMap<ReturnType<typeof usePlatformStore>, Promise<void>>();

/** The route guard owns startup, so the shell never races it for session state. */
export async function platformNavigation(
  to: Pick<RouteLocationNormalized, 'meta' | 'fullPath' | 'name'>,
  store: ReturnType<typeof usePlatformStore>
): Promise<RouteLocationRaw | true> {
  if (!store.bootstrapped) {
    let pending = startupRequests.get(store);
    if (!pending) {
      pending = store.bootstrap().finally(() => startupRequests.delete(store));
      startupRequests.set(store, pending);
    }
    await pending;
  }
  if (to.meta.auth && !store.user) return { name: 'login', query: { returnTo: to.fullPath } };
  if (to.meta.admin && store.user?.role !== 'admin') return { name: 'workspace' };
  if (to.name === 'login' && store.user) return { name: 'workspace' };
  return true;
}
